import React from 'react';
import { useSelector } from 'react-redux';

import IMG_NHS from 'assets/tags/discount.svg';
import PlanBenefitsSplashPanel from 'components/hr/timeOffSplash/TimeOffSplashPlanBenefitsPanel.component';
import ClientTagsSplashVideoContainer from 'components/tags/splash/ClientTagsSplashVideo.component';
import { COUNTRY_CODES } from 'constants/address/counties.const';
import { selectCurrentSalonCountryCode } from 'selectors/currentSalon.selectors';

import CN from './ClientTagsSplashBottomPanel.module.scss';

const ClientTagsSplashBottomPanel = () => {
  const countryCode = useSelector(selectCurrentSalonCountryCode);
  const isGBSalon = countryCode === COUNTRY_CODES.GB;

  return (
    <section data-bem="ClientTagsSplashBottomPanel" className={CN.component}>
      <ClientTagsSplashVideoContainer isGBSalon={isGBSalon} />
      <div data-bem="ClientTagsSplashBottomPanel__benefits" className={CN.cardBenefits}>
        <PlanBenefitsSplashPanel showTrialButton />
      </div>
      {isGBSalon && <img data-bem="ClientTagsSplashBottomPanel__nhs-mobile" src={IMG_NHS} className={CN.imgNHSMobile} alt="Graphics map discount icon" />}
      <span className={CN.blur1} data-bem="ClientTagsSplashBottomPanel__blur-1" />
      <span className={CN.blur2} data-bem="ClientTagsSplashBottomPanel__blur-2" />
    </section>
  );
};

// noinspection JSUnusedGlobalSymbols
export default ClientTagsSplashBottomPanel;
